import React from "react";
import "./App.scss";
import RoutesComponent from "./Routes";

function App() {
  return (
    <div className="App">
      <RoutesComponent />
    </div>
  );
}

export default App;
